<template>
	<div class="list-container init">
		<div class="cps-page-top">
			<div class="instance-list" v-if="listVisibile">
				<div class="jc-page-header">
					<el-page-header :title="$t('listPage.speechCraft.title')" />
					<div class="jc-box-action">
						<a v-bind:href="Config.CPS_HELP_URL" target="_blank">
							{{ $t('listPage.speechCraft.helpDocument') }}</a>
					</div>
				</div>
				<div class="jc-page-content">
					<div class="jc-container-table">
						<div class="jc-container-table-actionBar flex-display">
							<el-form class="jc-table-actionBar-item" :inline="true">
								<el-form-item>
									<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-radio-group v-model="region" @change="regionChange">
										<el-radio-button v-for="(area, index) in region_map" :key="index"
											:label="area.region">
											{{ area.regionName }}
										</el-radio-button>
									</el-radio-group>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="jumpToCreate">
										{{ $t('listPage.text.create') }}
									</el-button>
								</el-form-item>
							</el-form>
							<div class="search-input-list">
								<jcb-combined-search ref='combinedSearch' :filterGroup="filterGroup"
									:defaultKey="defaultKey" :tags="tags" :matchKeyFunction="matchKeyFunction"
									:noMatchedSearchKeyTip="$t('list.keySearch')"
									:matchSearchKeyIntroduction="$t('list.keySearchTip')" @search="handleSearch" />
								<el-form :inline="true" @submit.native.prevent>
									<!--tag-->
									<el-form-item>
										<jcb-tag-filter :service-code="ServiceCodeConstant.CPS"
											:visible.sync="batchEditTagDialogVisible" :region-id="region ? region : ''"
											@checkedTags="filterWithCheckedTags">
										</jcb-tag-filter>
									</el-form-item>
									<el-form-item>
										<el-button icon="el-icon-setting" class="jc-list__square-btn"
											@click="customVisible = true" style="height:32px;width:32px"
											:title="$t('listPage.text.customList')"></el-button>
									</el-form-item>
									<el-form-item>
										<el-button class="jc-list__square-btn" icon="jc-icon-download" @click="showDownload"
											style="height:32px;width:32px" :title="$t('listPage.text.exportList')">
										</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
						<div v-if="searchList" class="search-list">
							<span>{{ this.total === 0 ? $t('list.searchresult1', [total]) : $t('list.searchresult2',
								[total]) }}</span>
							<el-button type="text" @click="backTolist()">{{ $t('list.backTolist') }}
							</el-button>
						</div>
						<el-table @filter-change="filterChange" :data="tableData" style="width: 100%"
							class="jc-list-table jc-table-header-cell" v-loading="refreshloading" ref="listTable"
							:empty-text="$t('speechCraft.listEmptyText')" @selection-change="handleSelectionChange">
							<!-- 多选框-->
							<el-table-column type="selection" width="55" v-if="customInfo !== null">
							</el-table-column>
							<!--ID/实例名称-->
							<el-table-column :label="$t('listPage.tableLabel.idOrName')" width="300" key="id"
								v-if="customInfo !== null && customInfo['id'].selected">
								<template slot-scope="scope">
									<div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()">
										<el-tooltip placement="top" :content="scope.row.instanceId">
											<div class="left">
												<p class="instance-name">{{ scope.row.instanceId }}
												</p>
											</div>
										</el-tooltip>
										<div class="right" v-show="copyHover">
											<copy-value :copyVal="`${scope.row.instanceId}`"></copy-value>
										</div>
									</div>
									<!-- <br /> -->
									<div>
										<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
											<a href="javascript:void(0)" @click="jumpToDetail(scope.row.instanceId, scope.row.region, scope.row.az,
												scope.row.az_name, 'sourceInfo', scope.row.sn)" class="instance-name">{{ scope.row.name }}</a>
										</el-tooltip>
									</div>
									<!--操作系统图片-->
									<div>
										<el-tooltip class="item" effect="dark" :content="scope.row.osName"
											placement="top">
											<span :class="[scope.row.osType, 'os-icon']"></span>
										</el-tooltip>
									</div>
								</template>
							</el-table-column>
							<!-- 监控 -->
							<el-table-column min-width="60" :label="$t('privateNetInstance.listTitle.monitor')"
								v-if="customInfo !== null && customInfo['monitor'].selected">
								<template slot-scope="scope">
									<performance-monitor-icon :data="scope.row" @click.native="jumpToDetail(
										scope.row.instanceId,
										scope.row.region,
										scope.row.az,
										scope.row.az_name,
										'performanceMonitor',
										scope.row.sn, scope.row.imageType)" />
								</template>
							</el-table-column>
							<!--可用区-->
							<el-table-column prop="az" min-width="85" key="az"
								:label="$t('listPage.tableLabel.availableArea')" :filter-multiple="true"
								:filters="filters.azs" :filter-method="filterAz" column-key="filterAzKey"
								v-if="customInfo !== null && customInfo['az'].selected" filter-placement="bottom-start">
								<template slot-scope="scope">
									<span>{{ scope.row.az_name }}</span>
								</template>
							</el-table-column>
							<!--IP地址-->
							<el-table-column :label="$t('listPage.tableLabel.ipAddress')" min-width="170" key="ip"
								v-if="customInfo !== null && customInfo['ip'].selected">
								<template slot-scope="scope">
									<div>
										<div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()"
											v-if="scope.row.publicIp">
											<el-tooltip placement="top"
												:content="scope.row.publicIp + $t('privateNetInstance.public')">
												<div class="left">
													<p class="instance-ip">{{ scope.row.publicIp +
														$t('privateNetInstance.public') }}
													</p>
												</div>
											</el-tooltip>
											<div class="right" v-show="copyHover">
												<copy-value :copyVal="`${scope.row.publicIp}`"></copy-value>
											</div>
										</div>
										<p v-else>{{ '--' + $t('privateNetInstance.public') }}</p>
									</div>
									<div>
										<div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()"
											v-if="scope.row.privateIp">
											<el-tooltip placement="top"
												:content="scope.row.privateIp + $t('privateNetInstance.private')">
												<div class="left">
													<p class="instance-ip">{{ scope.row.privateIp +
														$t('privateNetInstance.private') }}
													</p>
												</div>
											</el-tooltip>
											<div class="right" v-show="copyHover">
												<copy-value :copyVal="`${scope.row.privateIp}`"></copy-value>
											</div>
										</div>
										<p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
									</div>
								</template>
							</el-table-column>
							<!--网络类型-->
							<el-table-column prop="networkTypeName" min-width="85" key="networkTypeName"
								:label="$t('listPage.tableLabel.netType')"
								v-if="customInfo !== null && customInfo['networkType'].selected">
							</el-table-column>
							<!--状态-->
							<el-table-column prop="status" :label="$t('listPage.tableLabel.status')" min-width="120"
								key="status" :filter-multiple="true" column-key="filterStatusKey" :filters=filters.status
								:filter-method="filterStatus" v-if="customInfo !== null && customInfo['status'].selected">
								<template slot-scope="scope">
									<el-tooltip v-if="scope.row.statusName === $t('listPage.text.error')" class="item"
										effect="dark" :content="$t('listPage.speechCraft.commitWorkSheet')" placement="top">
										<span @click="createErrorOrder" :class="['my-error-status', statusMap['error']]">
											{{ scope.row.statusName }}</span>
									</el-tooltip>
									<span v-if="scope.row.statusName === $t('listPage.text.run')" :class="statusMap['run']">
										{{ scope.row.statusName }}
									</span>
									<span v-if="scope.row.statusName === $t('listPage.text.shutdown')"
										:class="statusMap['shutdown']">
										{{ scope.row.statusName }}
									</span>
									<span v-if="statusList.indexOf(scope.row.statusName) <= -1"
										:class="statusMap['intermediate']">
										<span class="icon-status icon-stopped icon-run"></span>
										{{ scope.row.statusName }}
									</span>
								</template>
							</el-table-column>
							<!--规格类型-->
							<el-table-column min-width="115" column-key="filterSpecKey" key="specifications" v-if="region === 'cn-east-1' && customInfo !== null
								&& customInfo['specifications'].selected" prop="deviceType"
								:label="$t('listPage.tableLabel.specificationType')" :filter-multiple="true"
								:filters=filters.deviceTypes :filter-method="filterDeviceType"
								:filtered-value="filterDevice">
								<template slot-scope="scope">
									<span class="english-wrap">{{ scope.row.deviceTypeName }}</span>
								</template>
							</el-table-column>
							<el-table-column column-key="filterSpecKey" key="specifications" min-width="115" v-if="region === 'cn-north-1' && customInfo !== null
								&& customInfo['specifications'].selected" prop="deviceType"
								:label="$t('listPage.tableLabel.specificationType')" :filter-multiple="true"
								:filters=filters.deviceTypes :filter-method="filterDeviceType"
								:filtered-value="filterDevice">
								<template slot-scope="scope">
									<span class="english-wrap">{{ scope.row.deviceTypeName }}</span>
								</template>
							</el-table-column>
							<!--配置-->
							<el-table-column key="config" :label="$t('listPage.tableLabel.config')" min-width="150"
								v-if="customInfo !== null && customInfo['config'].selected">
								<template slot-scope="scope">
									<p>{{ scope.row.cpsConfiguration.cpu }}</p>
									<p>{{ scope.row.cpsConfiguration.mem }}</p>
									<p v-if="scope.row.cpsConfiguration.bw">{{ scope.row.cpsConfiguration.bw }}</p>
									<p v-else>--</p>
								</template>
							</el-table-column>
							<!--tag-->
							<!--标签-->
							<el-table-column :label="$t('listPage.text.tags')" key="tag"
								v-if="customInfo !== null && customInfo['tags'].selected" min-width="70"
								class-name="p-line-break">
								<template slot-scope="scope">
									<p>{{ scope.row.tagPairs | maybeEmpty }}</p>
								</template>
							</el-table-column>
							<!--计费信息-->
							<el-table-column key="charge" min-width="200"
								:label="$t('listPage.tableLabel.billingInformation')"
								v-if="customInfo !== null && customInfo['chargeInfo'].selected">
								<template slot-scope="scope">
									<div v-if="scope.row.expire !== undefined">
										<p>{{ scope.row.chargeDesc }}
											<span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="red">
												{{ '(' + $t('listPage.text.hasExpired') + ')' }}
											</span>
										</p>
                                        <p class="list-expire-p">
                                            {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                        </p>
										<p v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.retireTime"
											class="list-expire-p red">{{ scope.row.retireTime + ' ' +
												$t('listPage.text.freed') }}</p>
										<p v-if="getCheckExpireInfo(scope.row) === 'will-expire'" class="list-expire-p red">
											{{ scope.row.expire + ' ' +
												$t('listPage.text.expired') }}</p>
										<p v-if="getCheckExpireInfo(scope.row) === 'available'" class="list-expire-p">
											{{ scope.row.expire + ' ' + $t('listPage.text.expired') }}</p>
									</div>
									<div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
										<p>
											{{ scope.row.chargeDesc }}
											<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
												class="red">
												{{ '(' + $t('privateNetInstance.arrear') + ')' }}
											</span>
										</p>
										<p class="list-expire-p" v-if="scope.row.charge.chargeStatus === 'normal'">
											{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
										</p>
										<p class="list-expire-p red"
											v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
											{{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
										</p>
									</div>
									<div v-else>
										<span>--</span>
									</div>
								</template>
							</el-table-column>

							<!--操作-->
							<el-table-column key="operation" min-width="90" :label="$t('listPage.tableLabel.operation')"
								v-if="customInfo !== null && customInfo['operation'].selected">
								<template slot-scope="scope">
									<p>
										<!--开机-->
										<a class="cps-select-form-item" v-if="scope.row.status === 'stopped' || scope.row.status === 'stopping'
											|| scope.row.status === 'error' || scope.row.status === 'reinstalling'" href="javascript:void(0)" @click="selectOps(PopStatus.TURN_ON, scope.row, 'start',
		operateMap[statusListMap[scope.row.status]].indexOf('start') > -1,
		OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('start') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| !scope.row.chargeStatus
	}">
											{{ $t('operations.turn_on.name') }}
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip cps-form-tip-restart" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
											<div class="cps-form-tip cps-form-tip-restart" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('start') > -1
												|| OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('operations.turn_on.tip') }}
											</div>

										</a>
										<!--关机-->
										<a v-else href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.TURN_OFF, scope.row, 'turnOff',
											operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1,
											OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| !scope.row.chargeStatus
	}">
											{{ $t('operations.turn_off.name') }}
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip cps-form-tip-restart" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
											<div class="cps-form-tip cps-form-tip-restart" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1
												|| OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('operations.turn_off.tip') }}
											</div>

										</a>
									</p>
									<p>
										<!--重启-->
										<a href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.RESTART, scope.row, 'restart',
											operateMap[statusListMap[scope.row.status]].indexOf('restart') > -1,
											OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('restart') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| !scope.row.chargeStatus
	}">
											{{ $t('operations.restart.name') }}
											<!--无计费信息不支持操作-->
											<div class="cps-form-tip cps-form-tip-restart" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
											<div class="cps-form-tip cps-form-tip-restart" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('restart') > -1
												|| OverdueConstantArray.includes(scope.row.chargeStatus)">
												{{ $t('operations.restart.tip') }}
											</div>

										</a>
									</p>
									<!--更多-->
									<el-dropdown size="200px">
										<span class="jc-dropdown-link">
											{{ $t('operations.more') }}<i class="jc-icon-caret-bottom jc-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown" class="operation-list-dropdown-menu">
											<!--重置密码-->
											<a href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.RESET_PASSWORD, scope.row, 'resetPassword',
												operateMap[statusListMap[scope.row.status]].indexOf('resetPassword') > -1,
												OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('resetPassword') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus
	}">
												<el-dropdown-item :disabled="operateMap[statusListMap[scope.row.status]].indexOf('resetPassword') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													|| !scope.row.chargeStatus">
													{{ $t('operations.reset_password.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('resetPassword') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)">
													{{ $t('operations.reset_password.tip') }}
												</div>

											</a>
											<!--重装系统-->
											<a href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.REINSTALL, scope.row, 'reinstall',
												operateMap[statusListMap[scope.row.status]].indexOf('reinstall') > -1,
												OverdueConstantArray.includes(scope.row.chargeStatus) | !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('reinstall') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| !scope.row.chargeStatus
	}">
												<el-dropdown-item :disabled="operateMap[statusListMap[scope.row.status]].indexOf('reinstall') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													|| !scope.row.chargeStatus">
													{{ $t('operations.reinstall.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('reinstall') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)">
													{{ $t('operations.reinstall.tip') }}
												</div>

											</a>
											<!--调整带宽-->
											<a :title="operateMap[statusListMap[scope.row.status]].indexOf('bandWidth') > -1
												|| OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.publicIp === undefined ? '' :
												$t('operations.bandwidth.name')" href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.BANDWIDTH, scope.row, 'bandWidth',
		operateMap[statusListMap[scope.row.status]].indexOf('bandWidth') > -1,
		scope.row.publicIp === undefined || OverdueConstantArray.includes(scope.row.chargeStatus)
		|| !scope.row.chargeStatus)" :class="{
		'cps-dropdown-disabled': operateMap[statusListMap[scope.row.status]].indexOf('bandWidth') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| !scope.row.chargeStatus
	}">
												<el-dropdown-item :disabled="operateMap[statusListMap[scope.row.status]].indexOf('bandWidth') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.publicIp === undefined
													|| !scope.row.chargeStatus">
													{{ $t('operations.bandwidth.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="(operateMap[statusListMap[scope.row.status]].indexOf('bandWidth') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)) && scope.row.publicIp !== undefined">
													{{ $t('operations.bandwidth.tip') }}
												</div>
												<div class="cps-form-tip" v-else-if="scope.row.publicIp === undefined">{{
													$t('operations.bandwidth.tip_public_ip') }}
												</div>

											</a>
											<!--SOS-->
											<a v-if="scope.row.keypairIdSos !== undefined" href="javascript:void(0)"
												class="cps-select-form-item"
												@click="selectOps(PopStatus.SOS, scope.row, 'SOS', !scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows')">
												<el-dropdown-item
													:disabled="OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows' || !scope.row.chargeStatus">
													{{ $t('privateNetInstance.operations.sos') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="scope.row.imageType === 'Windows'">
													{{ $t('privateNetInstance.operations.notWindows') }}
												</div>
											</a>
											<!--重置SOS-->
											<a v-if="scope.row.keypairIdSos !== undefined" href="javascript:void(0)"
												class="cps-select-form-item"
												@click="selectOps(PopStatus.RESETSOS, scope.row, 'resetSOS', scope.row.chargeStatus === undefined || OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows')">
												<el-dropdown-item
													:disabled="!scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows'">
													{{ $t('privateNetInstance.operations.resetSOS') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="scope.row.imageType === 'Windows'">
													{{ $t('privateNetInstance.operations.notWindows') }}
												</div>
											</a>
											<!--修复SOS-->
											<a v-else href="javascript:void(0)" class="cps-select-form-item"
												@click="selectOps(PopStatus.FIXSOS, scope.row, 'fixSOS', !scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows')">
												<el-dropdown-item
													:disabled="!scope.row.chargeStatus || OverdueConstantArray.includes(scope.row.chargeStatus) || scope.row.imageType === 'Windows'">
													{{ $t('privateNetInstance.operations.fixSOS') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="scope.row.imageType === 'Windows'">
													{{ $t('privateNetInstance.operations.notWindows') }}
												</div>
											</a>
											<!--续费-->
											<a href="javascript:void(0)" class="cps-select-form-item" @click="selectOps(PopStatus.RENEW, scope.row, 'renew',
												operateMap[statusListMap[scope.row.status]].indexOf('renew') > -1
												|| scope.row.chargeStatus === undefined)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('renew') > -1
			|| scope.row.chargeStatus === undefined
	}
		">
												<el-dropdown-item :disabled="operateMap[statusListMap[scope.row.status]].indexOf('renew') > -1
													|| scope.row.chargeStatus === undefined
													">
													{{ $t('operations.renew.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="scope.row.chargeStatus === undefined">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
											</a>
											<!--编辑标签-->
											<a class="cps-select-form-item" href="javascript:void(0)" @click="selectOps(PopStatus.EDIT_TAG, scope.row, 'editTag',
												operateMap[statusListMap[scope.row.status]].indexOf('editTag') > -1,
												OverdueConstantArray.includes(scope.row.chargeStatus)
												|| scope.row.chargeStatus === undefined)" :class="{
		'cps-dropdown-disabled':
			operateMap[statusListMap[scope.row.status]].indexOf('editTag') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
			|| scope.row.chargeStatus === undefined
	}
		">
												<el-dropdown-item :disabled="operateMap[statusListMap[scope.row.status]].indexOf('editTag') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													|| scope.row.chargeStatus === undefined
													">
													{{ $t('operations.edit_tag.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip" v-else-if="operateMap[statusListMap[scope.row.status]].indexOf('editTag') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													|| scope.row.chargeStatus === undefined
													">
													{{ $t('operations.edit_tag.tip') }}
												</div>

											</a>
											<!--开启实例删除保护-->
											<a v-if="scope.row.removeProtect === 'no'" class="cps-select-form-item"
												href="javascript:void(0)" @click="selectOps(PopStatus.turnOnDeleteProtect, scope.row, 'turnOnDeleteProtect',
													scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													, scope.row.chargeStatus === undefined || OverdueConstantArray.includes(scope.row.chargeStatus))" :class="{
		'cps-dropdown-disabled':
			scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
			|| scope.row.chargeStatus === undefined
			|| operateMap[statusListMap[scope.row.status]].indexOf('turnOnDeleteProtect') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
	}
		">
												<el-dropdown-item :disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													|| scope.row.chargeStatus === undefined
													|| operateMap[statusListMap[scope.row.status]].indexOf('turnOnDeleteProtect') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													">
													{{ $t('operations.turnOnDeleteProtect.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip"
													v-else-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
													{{ $t('operations.turnOnDeleteProtect.prepaidTip') }}
												</div>
												<div class="cps-form-tip"
													v-else-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
													{{ $t('operations.delete.tipWithRemoveProtect') }}
												</div>

											</a>
											<!--关闭实例删除保护-->
											<a v-if="scope.row.removeProtect === 'yes'" class="cps-select-form-item"
												href="javascript:void(0)" @click="selectOps(PopStatus.turnOffDeleteProtect, scope.row, 'turnOnDeleteProtect',
													scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													, scope.row.chargeStatus === undefined)" :class="{
		'cps-dropdown-disabled':
			scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
			|| scope.row.chargeStatus === undefined
			|| operateMap[statusListMap[scope.row.status]].indexOf('turnOffDeleteProtect') > -1
			|| OverdueConstantArray.includes(scope.row.chargeStatus)
	}
		">
												<el-dropdown-item :disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													|| scope.row.chargeStatus === undefined
													|| operateMap[statusListMap[scope.row.status]].indexOf('turnOffDeleteProtect') > -1
													|| OverdueConstantArray.includes(scope.row.chargeStatus)
													">
													{{ $t('operations.turnOffDeleteProtect.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip"
													v-else-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
													{{ $t('operations.delete.tip') }}
												</div>
												<div class="cps-form-tip"
													v-else-if="OverdueConstantArray.includes(scope.row.chargeStatus)">
													{{ $t('operations.turnOffDeleteProtect.tip') }}
												</div>

											</a>
											<!--删除-->
											<a class="cps-select-form-item" href="javascript:void(0)"
												@click="selectOps(PopStatus.DELETE, scope.row, 'delete',
													scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													, scope.row.chargeStatus === undefined || scope.row.removeProtect === 'yes' || scope.row.status !== 'stopped')">
												<el-dropdown-item :disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
													|| scope.row.chargeStatus === undefined
													|| scope.row.status !== 'stopped'
													|| scope.row.removeProtect === 'yes'
													">
													{{ $t('operations.delete.name') }}
												</el-dropdown-item>
												<!--无计费信息不支持操作-->
												<div class="cps-form-tip cps-form-tip-restart"
													v-if="!scope.row.chargeStatus">
													{{ $t('eip.help.noChargeInfo') }}
												</div>
												<div class="cps-form-tip"
													v-else-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
													{{ $t('operations.delete.tip') }}
												</div>
												<div class="cps-form-tip cps-form-tip-restart"
													v-else-if="scope.row.status !== 'stopped'">
													{{ $t('operations.delete.tipWithStatus') }}
												</div>
												<div class="cps-form-tip" v-else-if="scope.row.removeProtect === 'yes'">
													{{ $t('operations.delete.tipWithRemoveProtect') }}
												</div>
											</a>
										</el-dropdown-menu>
									</el-dropdown>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div id="public_net">
					<el-dialog :title="$t('listPage.speechCraft.adjustPublicBandWidth')"
						:visible.sync="public_net_dialog_visible" size="default" :close-on-click-modal="false"
						@close="resetInitParams()" @open="public_net_slider_value = minBandwidth">
						<div class="i-text">
							<div class="tip-warning">
								{{ $t('listPage.speechCraft.tipWaring') }}
							</div>
						</div>
						<el-form ref="form" label-width="80px" class="mt20" onsubmit="return false">
							<el-form-item :label="$t('listPage.text.maxBandWidth') + ':'">
								<div class="block">
									<div class="el-form-item-inline">
										<el-slider v-model="public_net_slider_value" show-input @change="calPrice()"
											:max="200" :debounce="1000" :marks="marks" :min="minBandwidth"
											class="jc-slider-custom">
										</el-slider>
									</div>
								</div>
							</el-form-item>
						</el-form>
						<el-table :data="public_net_gridData" class="mt20 mb40">
							<el-table-column property="name" :label="$t('listPage.tableLabel.name')" width="110">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
										<span class="custom-ellipsis">{{ scope.row.name }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column property="public_ip" :label="$t('listPage.tableLabel.publicIp')">
								<template slot-scope="scope">
									<p style="margin-bottom:0px" v-if="scope.row.public_ip"
										:title="scope.row.public_ip + $t('listPage.text.publicIpv4')">
										{{ scope.row.public_ip }}{{ $t('listPage.text.publicIpv4') }}</p>
									<p v-else>--{{ $t('listPage.text.publicIpv4') }}</p>
									<el-tooltip v-if="scope.row.enableIpv6 === 'yes' && scope.row.public_ipv6 !== undefined
										&& scope.row.public_ipv6 !== ''
										" class="item" effect="dark" :content="scope.row.public_ipv6 + $t('listPage.text.publicIpv6')"
										placement="top">
										<span>{{ scope.row.public_ipv6 }}{{ $t('listPage.text.publicIpv6') }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column
								v-if="public_net_gridData[0] && public_net_gridData[0].server_data.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION"
								property="expire_date" :label="$t('listPage.tableLabel.expireTime')"
								width="160"></el-table-column>
							<el-table-column property="current_bandwidth"
								:label="$t('listPage.tableLabel.currentBandWidth')" width="115"></el-table-column>
							<el-table-column property="charge" :label="$t('listPage.tableLabel.billMethods')" width="114">
							</el-table-column>
						</el-table>
						<span>{{ $t('listPage.text.cost') + ': ' }}</span>
						<span style="color:#FAB418;font-size:24px">
							{{ $t('listPage.text.currencySymbol') }}{{ totalFee }}
						</span>
						<p v-if="totalDiscount !== '0.00' && totalDiscount !== '0' && totalDiscount !== 0">
							<span class="price" style="font-size:10px;text-decoration:line-through;">
								{{ $t('listPage.text.price') + ': ' + $t('listPage.text.currencySymbol') + totalPrice }}
							</span>
							<span class="discounted-total-price">
								{{ $t('listPage.text.saving') + ': ' + $t('listPage.text.currencySymbol') + totalDiscount }}
							</span>
						</p>
						<span slot="footer" class="dialog-footer">
							<el-button @click="public_net_dialog_visible = false">
								{{ $t('listPage.text.cancelButton') }}
							</el-button>
							<el-button type="primary" @click="public_net_confirm()" :disabled="public_net_slider_value <= minBandwidth
								|| public_net_slider_value > 200 || isNaN(public_net_slider_value)
								">
								{{ $t('listPage.text.sureButton') }}
							</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
			<custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type">
			</custom>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<div class="fl mt10">
				<el-checkbox @change="handleCheckAllChange" v-model="hasCheckAll" class="mr20"></el-checkbox>
				<el-tooltip placement="top" :disabled="isAllowBatchClose">
					<div slot="content">{{ multipleSelection.length ? $t('retailInstance.tooltip.turnOff') :
						$t('retailInstance.tooltip.chooseTips') }}</div>
					<span>
						<el-button type="primary" class="w70" :disabled="!isAllowBatchClose" @click="showBatchCloseDialog">
							{{ $t('privateNetInstance.shutdown') }}
						</el-button>
					</span>
				</el-tooltip>
				<el-tooltip placement="top" :disabled="isAllowBatchOpen">
					<div slot="content">{{ multipleSelection.length ? $t('retailInstance.tooltip.turnOn') :
						$t('retailInstance.tooltip.chooseTips') }}</div>
					<span>
						<el-button type="primary" class="w70" :disabled="!isAllowBatchOpen" @click="showBatchOpenDialog">
							{{ $t('privateNetInstance.open') }}
						</el-button>
					</span>
				</el-tooltip>
				<drop-down-operation class="batch-operation-button" :showType="'button'"
					:buttonTitle="$t('privateNetInstance.more')" :operations="batchOperations"
					@clickSelectItem="clickBatchOperate">
				</drop-down-operation>
			</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="currentRow"
			@refreshData="updateList('refresh')">
		</reset-password>
		<!--删除实例-->
		<delete-instance :visible.sync="deleteVisible" @refresh="updateList('refresh')" :rowInfo="currentRow"
			:pageSource="'list'">
		</delete-instance>
		<have-sos :visible.sync="sosShow" :rowInfo="rowInfo" @refresh="updateList('refresh')">
		</have-sos>
		<fix-sos :visible.sync="fixSOSShow" :rowInfo="rowInfo" @refresh="updateList('refresh')">
		</fix-sos>
		<reset-sos :visible.sync="resetSOSShow" :rowInfo="rowInfo" @refresh="updateList('refresh')">
		</reset-sos>
		<!--重装系统弹框-->
		<reinstall :visible.sync="sys_rein_dialog_visible" :rowInfo="rowInfo" @openReConfirm="openReConfirm"
			v-if="sys_rein_dialog_visible">
		</reinstall>
		<!--重装系统二次确认弹框-->
		<resys :visible.sync="sys_rein_confirm_dialog_visible" :formInfo="reSysForm" :rowInfo="reSystemInfo"
			@refresh="updateList('refresh')" v-if="sys_rein_confirm_dialog_visible">
		</resys>
		<jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType" @success="onSuccess"
			@error="onError">
		</jcb-opt-protect>
		<!--编辑标签-->
		<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPS" :region-id="currentRow !== undefined && currentRow.region !== undefined ?
			currentRow.region : ''
			" :resource-ids="currentRow !== undefined && currentRow.region !== undefined ?
		[currentRow.instanceId] : []
		" @complete="updateList('refresh')">
		</jcb-tag-edit>
		<!-- 下载 -->
		<download-selection :visible.sync="downloadVisible" :currentPage="currentPage" :pageSize="pageSize"
			:filterParams="filterParams" :searchParams="params" :networkType="networkType"
			:multipleSelection="multipleSelection" :region="region" @refresh="updateList('refresh')">
		</download-selection>
		<!--批量关机-->
		<batch-close :visible.sync="batchCloseVisible" @refresh="batchOperateRefresh" :multipleSelection="multipleSelection"
			:showDifferent="showDifferent" :region="region">
		</batch-close>
		<!-- 批量开机 -->
		<batch-open :visible.sync="batchOpenVisible" @refresh="batchOperateRefresh" :multipleSelection="multipleSelection"
			:showDifferent="showDifferent" :region="region">
		</batch-open>
		<!-- 批量重启 -->
		<batch-restart :visible.sync="batchRestartVisible" @refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection" :showDifferent="showDifferent" :region="region">
		</batch-restart>
		<!--批量编辑标签-->
		<jcb-tag-edit :visible.sync="batchEditTagDialogVisible" :service-code="ServiceCodeConstant.CPS"
			:region-id="region ? region : ''" :resource-ids="multipleSelectionId" @complete="batchOperateRefresh">
		</jcb-tag-edit>
		<!-- 批量重置密码 -->
		<batch-repassword :visible.sync="batchRepasswordVisible" @refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
		</batch-repassword>
		<!-- 批量编辑实例名称 -->
		<batch-rename :visible.sync="batchRenameVisible" @refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
		</batch-rename>
		<!-- 批量删除 -->
		<batch-delete :visible.sync="batchDeleteVisible" @refresh="batchOperateRefresh"
			:multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
		</batch-delete>
		<!--开启实例删除操作保护-->
		<enable-deletion-protection :visible.sync="enableDeletionProtectionVisible" :instanceName="currentRow.name"
			:region="currentRow.region" :instanceId="currentRow.instanceId" @refresh="updateList('refresh')">
		</enable-deletion-protection>
		<!--关闭实例删除操作保护-->
		<disable-deletion-protection :visible.sync="disableDeletionProtectionVisible" :instanceName="currentRow.name"
			:region="currentRow.region" :instanceId="currentRow.instanceId" @refresh="updateList('refresh')">
		</disable-deletion-protection>
	</div>
</template>

<script>
import {
	PopStatus,
	NetworkTypeConstant,
	CreateTypeConstant,
	OperationConstant,
	ServiceCodeConstant,
	PasswordRuleConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ChargeModeConstant
} from
	'@/common/Constants';
import custom from '@/components/common/custom/Custom';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import operationProtect from '@/mixins/operationProject';
import CustomData from '@/components/common/customData/CustomData';
import PerformanceMonitorIcon from '@/components/common/PerformanceMonitorIcon'
import loginMethods from '@/components/common/loginMethods/LoginMethods';
import DeleteInstance from '@/components/common/DeleteInstance';
import reinstall from '@/components/privateNetInstance/operates/ReSystem';
import resys from '@/components/privateNetInstance/operates/ReSysConfirm';
import BatchClose from '@/components/common/BatchClose';
import BatchOpen from '@/components/common/BatchOpen';
import BatchRestart from '@/components/common/BatchRestart';
import BatchRepassword from '@/components/common/BatchRepassword';
import BatchRename from '@/components/common/BatchRename';
import BatchDelete from '@/components/common/BatchDelete';
import HaveSos from '@/components/common/HaveSos';
import FixSos from '@/components/common/FixSos';
import ResetSos from '@/components/common/ResetSos';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import { getUserQuotas } from '@/api/basicInstance/list/actions';
import { deepCopy } from '@/common/tool';
import DownloadSelection from '@/components/common/retailInstance/DownloadSelection';
import copyValue from '@/components/privateNetwork/CopyValue';
const statusMap = {
	// 关机
	'shutdown': 'jc-status-warning',
	// 运行
	'run': 'jc-status-success',
	// 中间态
	'intermediate': 'my-status-middle ',
	// 错误
	'error': 'jc-status-danger',
	// 未知
	'未知': 'jc-status-danger'
};

const initPage = 1;

export default {
	components: {
		CustomData,
		custom,
		ResetPassword,
		loginMethods,
		PerformanceMonitorIcon,
		DeleteInstance,
		dropDownOperation,
		reinstall,
		resys,
		BatchClose,
		BatchOpen,
		BatchRestart,
		BatchRepassword,
		BatchRename,
		BatchDelete,
		HaveSos,
		FixSos,
		ResetSos,
		DownloadSelection,
		copyValue,
		EnableDeletionProtection,
		DisableDeletionProtection
	},
	name: 'List',
	mixins: [operationProtect],
	data() {
		const validatePassword = (rule, value, callback) => {
			var rule = PasswordRuleConstant;
			const result = rule.test(value);
			if (!result) {
				callback(new Error(this.$t('listPage.errorMessage.passwordRule[0]')));
				return;
			}
			callback();
		};

		const validateConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('listPage.errorMessage.passwordRule[0]')));
			} else if (value !== this.sys_rein_form.password) {
				callback(new Error(this.$t('listPage.errorMessage.passwordRule[1]')));
			} else {
				callback();
			}
		};

		// hostName验证规则
		const validatehostName = (rule, value, callback) => {
			if (value === '') {
				callback();
			}
			const hostRule = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.]){2,64}$)|(^\s*$)/;
			if (!hostRule.test(value)) {
				this.ruleFormTag.hostName = 'false';
				callback(new Error());
			} else {
				this.ruleFormTag.hostName = 'true';
				callback();
			}
		};

		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'id',
				searchLabel: this.$t('listPage.text.exampleID')
			},
			{
				searchValue: 'name',
				searchLabel: this.$t('listPage.text.exampleName')
			},
			{
				searchValue: 'privateIp',
				searchLabel: this.$t('privateNetInstance.intranetIp')
			}
		];
		return {
			PopStatus,
			quotaState: -100,
			helpVisible: false,
			listVisibile: false,
			rules: {
				password: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				confirmPassword: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				],
				hostName: [
					{
						validator: validatehostName,
						trigger: 'blur'
					}
				]
			},
			ruleFormTag: {
				password: 0,
				confirmPassword: 0,
				hostName: 'true'
			},
			timer: [],
			setIntervalTime: 5000, // 定时器时间
			clientToken: Normal.getClientToken(),
			filters_1: [],
			filters_4: [
				{ text: this.$t('listPage.text.powerIn'), value: 'starting' },
				{ text: this.$t('listPage.text.run'), value: 'running' },
				{ text: this.$t('listPage.text.shuttingDown'), value: 'stopping' },
				{ text: this.$t('listPage.text.shutdown'), value: 'stopped' },
				{ text: this.$t('listPage.text.error'), value: 'error' },
				{ text: this.$t('listPage.text.rebooting'), value: 'restarting' },
				{ text: this.$t('listPage.text.creating'), value: 'creating' },
				{ text: this.$t('listPage.text.destroying'), value: 'destroying' },
				{ text: this.$t('listPage.text.reconfiging'), value: 'upgrading' },
				{ text: this.$t('listPage.text.reinstalling'), value: 'reinstalling' },
				{ text: this.$t('listPage.text.resettingPassword'), value: 'resetting_password' },
			],
			// 数据盘提示列表
			raidsNameMap: {
				NORAID: 'NO RAID',
				RAID0: 'RAID0',
				RAID1: 'RAID1',
				RAID10: 'RAID10',
				RAID5: 'RAID5',
				RAID51H: 'RAID 5+1 hotspare+NO RAID'
			},
			customRaidsNameMap: {
				RAID51H: 'RAID 5+1 hotspare',
			},
			// 把所有的状态归纳为几类
			statusListMap: {
				'starting': 'other',
				'running': 'running',
				'stopping': 'other',
				'stopped': 'stopped',
				'error': 'error',
				'restarting': 'other',
				'creating': 'creating',
				'destroying': 'destroying',
				'upgrading': 'upgrading',
				'reinstalling': 'other',
				'noOperate': 'noOperate',
				'other': 'other',
				'resetting_password': 'other',
			},
			centerStatus: ['reinstalling', 'upgrading', 'destroying', 'creating', 'restarting',
				'stopping', 'starting', 'noOperate', 'resetting_password'],
			// 状态对应的不能进行的操作
			operateMap: {
				stopped: [
					'restart',
				],
				running: [
					'reinstall',
					'resetPassword',
					'delete'
				],
				error: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'editTag',
					'sos',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				],
				creating: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'sos',
					'editTag',
					'sos',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				],
				upgrading: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'sos',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				],
				destroying: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'sos',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				],
				other: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					// 'renew'
					'sos',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				],
				noOperate: [
					'starting',
					'running',
					'stopping',
					'stopped',
					'error',
					'restarting',
					'creating',
					'destroying',
					'upgrading',
					'reinstalling',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete'
				]
			},
			statusList: [
				this.$t('listPage.text.run'),
				this.$t('listPage.text.shutdown'),
				this.$t('listPage.text.error')
			],
			filterDevice: [],
			networkTypeMap: {
				basic: this.$t('listPage.text.baseNet')
			},
			chargeModeMap: {
				prepaid_by_duration: this.$t('listPage.text.prepaid_by_duration'),
				postpaid_by_duration: this.$t('listPage.text.postpaid_by_duration'),
			},
			statusMap,
			currentPage: initPage,
			gotoPage: 20,
			form: {},
			rowInfo: {},
			region_map: [],
			region: null,
			tableData: [],
			// dialog公网
			public_net_dialog_visible: false,
			public_net_slider_value: 0,
			public_net_gridData: [],
			// 重装系统
			sys_rein_dialog_visible: false,
			sys_rein_confirm_dialog_visible: false,
			downloadVisible: false,
			sosShow: false,
			fixSOSShow: false,
			resetSOSShow: false,
			reSysForm: {},
			reSystemInfo: {},
			sys_rein_gridData: [{
				name: '',
			}],
			sys_rein_radio: this.$t('listPage.text.currentMirror'),
			sys_rein_form: {
				mirror: '',
				admin: 'root',
				password: '',
				confirmPassword: '',
				disk: false,
				delivery: false,
				type: [],
				systemType: this.selectedOSTypeId,
				resource: '',
				desc: '',
				application: this.selectedApplication,
				hostName: '',
				loginType: 'pwd'
			},
			totalFee: 0,
			totalDiscount: 0,
			totalPrice: 0,
			imageTypes: { 'standard': this.$t('listPage.text.standardImage') },
			osTypes: {},
			standardOsTypes: {},
			refreshloading: false,
			customOsTypes: {},
			selectedImageType: 'standard',
			initImageType: '',
			regionMap: {},
			selectedOS: '',
			selectedOSTypeId: '',
			selectedOSVersion: '',
			applications: [],
			selectedApplication: [],
			ruleFormType: {
				type: this.selectedOSTypeId,
				application: this.selectedApplication
			},
			raids: [],
			// 选择的系统盘ID
			selectedOSRaidId: '',
			// 选择的数据盘ID
			selectedDataRaidId: '',
			minBandwidth: 0,
			idSearch: '',
			nameSearch: '',
			search: 'instanceId',
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			pageSize: 20,
			networkType: 'basic',
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// ID/名称
					label: this.$t('listPage.tableLabel.idOrName'),
					value: 'id'
				},
				{
					// 监控
					label: this.$t('privateNetInstance.listTitle.monitor'),
					value: 'monitor'
				},
				{
					// 可用区
					label: this.$t('list.region'),
					value: 'az'
				},
				{
					// IP地址
					label: this.$t('list.ip'),
					value: 'ip'
				},
				{
					// 网络类型
					label: this.$t('list.netWorkType'),
					value: 'networkType'
				},
				{
					// 状态
					label: this.$t('list.status'),
					value: 'status'
				},
				{
					// 规格
					label: this.$t('list.specifications'),
					value: 'specifications'
				},
				{
					// 配置
					label: this.$t('list.config'),
					value: 'config'
				},
				{
					// 标签
					label: this.$t('listPage.text.tags'),
					value: 'tags'
				},
				{
					// 计费信息
					label: this.$t('list.chargeInfo'),
					value: 'chargeInfo'
				},
				{
					// 操作
					label: this.$t('listPage.tableLabel.operation'),
					value: 'operation'
				}
			],
			// 自定义列表类型
			type: 'instanceList',
			filterGroup:
				[
					{	//实例名称
						label: this.$t('privateNetInstance.instanceName'),
						key: "name",
						multiValue: false,
						notice: this.$t('list.fuzzySearchTip')
					},
					{	//实例ID
						label: this.$t('privateNetInstance.instanceID'),
						key: "instanceId",
						multiValue: true,
						notice: this.$t('list.exactSearchTip')
					},
					{	//IPv4公网
						label: this.$t('subnet.text.publicIp'),
						key: "publicIp",
						multiValue: true,
						notice: this.$t('list.exactSearchTip')
					},
					{	//IPv4内网
						label: this.$t('subnet.text.privateIp'),
						key: "privateIp",
						matchModes: [{
							key: "fuzzy",
							label: this.$t('list.fuzzySearch')
						}, {
							key: "exact",
							label: this.$t('list.exactSearch')
						}],
						notice: this.$t('list.IPsearchTip')
					},
					{ 	//状态
						label: this.$t('list.status'),
						key: "filterStatusKey",
						multiValue: true,
						selectOptions: [],
						notice: this.$t('list.mutisearchTip')
					},
					{ 	//规格类型
						label: this.$t('list.specifications'),
						key: "filterSpecKey",
						multiValue: true,
						selectOptions: [],
						notice: this.$t('list.mutisearchTip')
					},
				],
			defaultKey: "name",
			tags: [],
			params: {},
			searchList: false,
			copyHover: false,
			searchLists: {
				azs: [],
				interfaceModes: [],
				deviceTypes: [],
				status: []
			},
			filters: {
				azs: [],
				deviceTypes: [],
				status: []
			},
			filterParams: {
				az: '',
				deviceTypeList: '',
				status: ''
			},
			status: '',
			az: '',
			deviceType: '',
			isAbsolute: true,
			// 代替代码中'未知'中文字段
			unknown: this.$t('listPage.text.unknown'),
			// 代替代码中'中间态'中文字段
			intermediate: this.$t('listPage.text.intermediate'),
			resetPasswordDialogVisible: false,
			// 当前行数据
			currentRow: {},
			// 重装系统二次确认的checkbox
			reinstallConfirmChecked: false,
			// 选择的数据盘Type
			selectedDataRaidType: '',
			// 给操作保护用的区分当前物理机类型
			instanceType: 'basic',
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			// 删除实例弹框
			deleteVisible: false,
			multipleSelection: [],
			multipleSelectionInstanceInfo: {},
			isAllowBatchClose: false,
			isAllowBatchOpen: false,
			isAllowBatchRestart: false,
			isAllowBatchEditTag: false,
			isAllowBatchRepassword: false,
			isAllowBatchRename: false,
			isAllowBatchDelete: false,
			batchCloseVisible: false,
			batchOpenVisible: false,
			batchRestartVisible: false,
			batchEditTagDialogVisible: false,
			batchRepasswordVisible: false,
			batchRenameVisible: false,
			batchDeleteVisible: false,
			hasCheckAll: false,
			showDifferent: {
				hasCollapse: false,
				ipLabelType: "Ip",
				hasBandWith: true
			},
			showDifferent1: {
				hasCollapse: true,
				ipLabelType: "Ip",
				hasBandWith: true
			},
			//带宽上限的上限和下限
			marks: { [this.minBandwidth]: '1Mbps', 200: '200Mbps' },
			// 开启实例删除操作保护弹框
			enableDeletionProtectionVisible: false,
			// 关闭实例删除操作保护弹框
			disableDeletionProtectionVisible: false,
		};
	},
	beforeRouteLeave(to, from, next) {
		this.clearTimer();
		next();
	},
	computed: {
		customInfo() {
			return this.$store.state.customInfo[this.type];
		},
		OperationConstant: () => OperationConstant,
		ServiceCodeConstant: () => ServiceCodeConstant,
		ChargeModeConstant: () => ChargeModeConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		ArrearConstantArray: () => ArrearConstantArray,
		batchOperations() {
			const operations = [{
				operateName: this.$t('operations.reset_password.name'),
				disabled: !this.isAllowBatchRepassword,
				tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.repassword') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'repassword'
			}, {
				operateName: this.$t('privateNetInstance.restart'),
				disabled: !this.isAllowBatchRestart,
				tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.restart') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'restart'
			}, {
				operateName: this.$t('operations.rename.name'),
				disabled: !this.isAllowBatchRename,
				tip: this.multipleSelection.length ? '' : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'rename'
			}, {
				operateName: this.$t('operations.edit_tag.name'),
				disabled: !this.isAllowBatchEditTag,
				tip: this.multipleSelection.length ? this.$t('operations.edit_tag.tip') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'editTag'
			}, {
				operateName: this.$t('operations.delete.name'),
				disabled: !this.isAllowBatchDelete,
				tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.delete') : this.$t('retailInstance.tooltip.chooseTips'),
				value: 'delete'
			},]
			return operations
		},
		multipleSelectionId() {
			return this.multipleSelection.map(item => item.instanceId)
		}
	},
	watch: {
		region(newValue) {
			if (newValue) {
				this.regionChange()
			}
		},
		quotaState(newValue, oldValue) {
			if (newValue === 1) {
				this.helpVisible = false;
				this.listVisibile = true;
			} else {
				this.helpVisible = true;
				this.listVisibile = false;
			}
		},
		listVisibile(newValue, oldValue) {
			if (newValue) {
				this.getRegion();
				this.checkPage();
				this.sys_rein_form.password = '';
				this.sys_rein_form.confirmPassword = '';
			}
		},
		// 操作系统变化清空系统版本
		selectedOS() {
			this.selectedOSTypeId = '';
		},
		selectedOSTypeId(newValue, oldVlue) {
			this.sys_rein_form.systemType = newValue;
			this.selectedApplication = [];
		},
		selectedImageType(newValue, oldVlue) {
			if (newValue !== 'standard_app') {
				this.osTypes = $.extend(true, {}, this.standardOsTypes);
			} else {
				this.selectedOS = 'CentOS';
				this.osTypes = $.extend(true, {}, this.customOsTypes);
			}
			if (newValue === 'standard_app' && this.selectedRegion && this.selectedOS === 'CentOS') {
			}
			this.getAvailableOs(this.selectedImageType);
			this.selectedOSTypeId = '';
			this.selectedApplication = [];
		},
		selectedApplication(newValue, oldVlue) {
			this.sys_rein_form.application = newValue;
			if (newValue.length) {
				this.ruleFormTag.application = 0;
			}
		}
	},
	created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
	},
	mounted() {
		this.getQuota();
	},
	methods: {
		/**
		 **@disc: 根据标签对实例进行过滤
		 **@author: mengln
		 */
		filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
			if (tagKeys.length !== 0) {
				this.filteredResourceIds = resourceIds;
			} else {
				this.filteredResourceIds = [];
			}
			this.updateList();
		},
		/**
		 * 获得组件传出的值
		 * @param loginType
		 * @param password
		 */
		getPassword(loginType, password) {
			this.sys_rein_form.loginType = loginType;
			this.sys_rein_form.password = password;
			this.sys_rein_form.confirmPassword = password;
		},
		/**
		 * 判断当前时间与到期、释放时间关系
		 * @param row
		 * @return {string}
		 */
		getCheckExpireInfo(row) {
			if (row.charge.chargeExpiredTime !== undefined) {
				const now = Date.now();
				const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
				const DAYS = 1000 * 60 * 60 * 24;
				if (now > expire && row.charge.chargeRetireTime) {
					return 'will-retire';
				}
				if (expire - now > 7 * DAYS) {
					return 'available';
				}
				return 'will-expire';
			}
		},
		getQuota() {
			const params = {
				serviceCode: ServiceCodeConstant.CPS
			};
			getUserQuotas(params)
				.then((json) => {
					this.quotaState = 1;
				})
				.catch((err) => {
					this.quotaState = -99;
				});
		},
		clearTimer() {
			if (this.timer.length > 0) {
				for (let i = 0; i < this.timer.length; i++) {
					clearTimeout(this.timer[i]);
				}
			}
		},
		resetInitParams() {
			this.public_net_slider_value = this.minBandwidth;
			this.totalFee = 0;
			this.totalDiscount = 0;
			this.totalPrice = 0;
		},
		openReConfirm(formInfo, rowInfo) {
			this.reSysForm = formInfo;
			this.reSystemInfo = rowInfo;
			this.sys_rein_confirm_dialog_visible = true;
			// this.closeInstance = true;
		},
		getRegion() {
			const params = {
				networkType: NetworkTypeConstant.BASIC
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
					res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.region_map.push(tempFormat);
					});
				}
			})
				.catch()
				.finally(() => {
					this.loading = false
				});
		},
		updateList(type) {
			const target = this;
			// 筛选暂时前端筛选  后面量大改为后端
			if (type === 'refresh') {
				this.refreshloading = true;
			}
			const param = {
				region: target.region,
				pageNumber: target.currentPage,
				pageSize: target.pageSize,
				networkType: NetworkTypeConstant.BASIC// 网络类型：1、basic（基础网络实例）2、vpc（私有网络实例）
			};
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
					param[key] = this.filterParams[key];
				}
			});

			const realParams = Object.assign({}, param, target.params);
			Ajax.get({
				action: '/listInstances',
				param: realParams,
				success: (data) => {
					this.refreshloading = false;
					const list = data.instances;
					let intervalFlag = false;
					if (list && list.length > 0) {
						for (let i = 0; i < list.length; i++) {
							let az_name = '';
							for (const index in target.filters.azs) {
								if (list[i].az === target.filters.azs[index].value) {
									az_name = target.filters.azs[index].text;
								}
							}
							// list[i].status = 'reinstalling'
							// 关机状态
							// list[i].status = "Stopped";
							let statusName = this.intermediate;
							let statusFlag = false;
							for (const loc in target.filters_4) {
								if (list[i].status === target.filters_4[loc].value) {
									statusName = target.filters_4[loc].text;
									statusFlag = true;
								}
							}
							// 如果状态找不到
							if (!statusFlag) {
								statusName = this.unknown,
									list[i].status = 'noOperate';
							}
							// 判断是否有中间状态，有则一直刷新。
							if (this.centerStatus.indexOf(list[i].status) > -1) {
								intervalFlag = true;
							}

							// 格式化显示字段
							list[i].az_name = az_name;
							list[i].statusName = statusName;
							list[i].deviceTypeName = list[i].cpsConfiguration.deviceType.name;
							list[i].networkTypeName = target.networkTypeMap[list[i].networkType];
							list[i].chargeDesc = target.chargeModeMap[list[i].charge.chargeMode];
							list[i].chargeMode = list[i].charge.chargeMode;
							// 未使用服务端运营状态
							// list[i].chargeStatusDesc = target.chargeStatusMap[list[i].charge.chargeStatus];
							list[i].expire = list[i].charge.chargeExpiredTime;
							list[i].retireTime = list[i].charge.chargeRetireTime;
							list[i].chargeStatus = list[i].charge.chargeStatus;
							// 格式化返回的标签键值对
							list[i].tagPairs = '';
							if (list[i].tags !== undefined && list[i].tags.length > 0) {
								for (const tag of list[i].tags) {
									list[i].tagPairs += `${tag.key}:${tag.value},`;
								}
								list[i].tagPairs = list[i].tagPairs.substring(0, list[i].tagPairs.length - 1);
							}
						}
						target.tableData = list;
						target.total = data.totalCount;
					} else {
						target.tableData = data.instances;
						target.total = data.totalCount;
					}
					let multipleSelectionInstanceInfo = deepCopy(target.multipleSelectionInstanceInfo)
					target.$nextTick(() => {
						target.tableData.map(item => {
							let instanceId = item.instanceId;
							if (multipleSelectionInstanceInfo[instanceId]) {
								target.$refs.listTable.toggleRowSelection(item, true)
							}
						})
					})
					target.clearTimer();
					if (intervalFlag) {
						target.timer.push(setTimeout(target.updateList, target.setIntervalTime));
					}
				},
				fail: (data) => {
					this.refreshloading = false;
				}
			});
		},
		searchOfList(type) {
			const target = this;
			// 筛选暂时前端筛选  后面量大改为后端
			if (type === 'refresh') {
				this.refreshloading = true;
			}
			const param = {
				region: target.region,
				pageNumber: 1,
				pageSize: target.pageSize,
				networkType: NetworkTypeConstant.BASIC// 网络类型：1、basic（基础网络实例）2、vpc（私有网络实例）
			};
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
					param[key] = this.filterParams[key];
				}
			});

			const realParams = Object.assign({}, param, target.params);
			Ajax.get({
				action: '/listInstances',
				param: realParams,
				success: (data) => {
					this.refreshloading = false;
					const list = data.instances;
					let intervalFlag = false;
					if (list && list.length > 0) {
						for (let i = 0; i < list.length; i++) {
							let az_name = '';
							for (const index in target.filters.azs) {
								if (list[i].az === target.filters.azs[index].value) {
									az_name = target.filters.azs[index].text;
								}
							}
							// list[i].status = 'reinstalling'
							// 关机状态
							// list[i].status = "Stopped";
							let statusName = this.intermediate;
							let statusFlag = false;
							for (const loc in target.filters_4) {
								if (list[i].status === target.filters_4[loc].value) {
									statusName = target.filters_4[loc].text;
									statusFlag = true;
								}
							}
							// 如果状态找不到
							if (!statusFlag) {
								statusName = this.unknown,
									list[i].status = 'noOperate';
							}
							// 判断是否有中间状态，有则一直刷新。
							if (this.centerStatus.indexOf(list[i].status) > -1) {
								intervalFlag = true;
							}

							// 格式化显示字段
							list[i].az_name = az_name;
							list[i].statusName = statusName;
							list[i].deviceTypeName = list[i].cpsConfiguration.deviceType.name;
							list[i].networkTypeName = target.networkTypeMap[list[i].networkType];
							list[i].chargeDesc = target.chargeModeMap[list[i].charge.chargeMode];
							list[i].chargeMode = list[i].charge.chargeMode;
							// 未使用服务端运营状态
							// list[i].chargeStatusDesc = target.chargeStatusMap[list[i].charge.chargeStatus];
							list[i].expire = list[i].charge.chargeExpiredTime;
							list[i].retireTime = list[i].charge.chargeRetireTime;
							list[i].chargeStatus = list[i].charge.chargeStatus;
							// 格式化返回的标签键值对
							list[i].tagPairs = '';
							if (list[i].tags !== undefined && list[i].tags.length > 0) {
								for (const tag of list[i].tags) {
									list[i].tagPairs += `${tag.key}:${tag.value},`;
								}
								list[i].tagPairs = list[i].tagPairs.substring(0, list[i].tagPairs.length - 1);
							}
						}
						target.tableData = list;
						target.total = data.totalCount;
					} else {
						target.tableData = data.instances;
						target.total = data.totalCount;
					}
					let multipleSelectionInstanceInfo = deepCopy(target.multipleSelectionInstanceInfo)
					target.$nextTick(() => {
						target.tableData.map(item => {
							let instanceId = item.instanceId;
							if (multipleSelectionInstanceInfo[instanceId]) {
								target.$refs.listTable.toggleRowSelection(item, true)
							}
						})
					})
					target.clearTimer();
					if (intervalFlag) {
						target.timer.push(setTimeout(target.updateList, target.setIntervalTime));
					}
				},
				fail: (data) => {
					this.refreshloading = false;
				}
			});
		},
		calPrice() {
			const target = this;
			const server_data = target.public_net_gridData[0].server_data;
			const params = {
				cmd: 3,
				resourceId: server_data.instanceId,
				region: server_data.region,
				timeUnit: 3,
				timeSpan: 12,
				bw: this.public_net_slider_value,
				count: 1,
				deviceType: server_data.deviceType,
				createType: CreateTypeConstant.BASIC,
				billingType: server_data.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : 1
			};
			Ajax.get({
				url: '/api/price',
				action: '/calculateTotalPrice',
				param: params,
				success: (data) => {
					target.totalFee = data.discountedTotalPrice;
					target.totalPrice = data.totalPrice;
					target.totalDiscount = data.totalDiscount;
				}
			});
		},
		checkPage() {
			const minPage = 1;
			let maxPage = Math.ceil(this.total / this.pageSize);
			if (maxPage < minPage) {
				maxPage = minPage;
			}
			if (this.gotoPage <= minPage) {
				this.gotoPage = 1;
				$('#firstpage').addClass('no').siblings().removeClass('no');
			}
			if (this.gotoPage >= maxPage) {
				this.gotoPage = maxPage;
				$('#lastpage').addClass('no').siblings().removeClass('no');
			}
			if (minPage === maxPage) {
				$('#firstpage').addClass('no').siblings().removeClass('no');
				$('#lastpage').addClass('no');
			}
		},
		setPage(page = null) {
			if (page === '+') {
				this.gotoPage++;
			} else if (page === '-') {
				this.gotoPage--;
			}
			this.checkPage();
			if (this.gotoPage !== this.currentPage) {
				this.currentPage = this.gotoPage;
				this.updateList();
			}
		},
		// 选择地区
		regionChange() {
			// TODO remember to clear search
			this.$refs.listTable.clearFilter();
			this.status = '';
			this.deviceType = '';
			this.az = '';
			this.currentSearchValue = '';
			this.currentPage = initPage;
			this.gotoPage = initPage;
			this.getFilterLists();
			this.updateList('refresh');
		},
		// 选择分页数
		setPageSize() {
			this.pageSize = $('#page_size option:selected').val();
			this.updateList();
		},
		filterStatus(value, row) {
			if (value) {
				this.searchList = true
			}
			return row.status === value;
		},
		filterAz(value, row) {
			if (value) {
				this.searchList = true
			}
			return row.az === value;
		},
		filterDeviceType(value, row) {
			if (value) {
				this.searchList = true
			}
			return row.deviceType === value;
		},
		ipHover() {
			this.copyHover = true
		},
		ipDisplayNone() {
			this.copyHover = false
		},
		jumpToDetail(id, region, az, azName, tabName = 'sourceInfo', sn, imageType) {
			this.$router.push({
				path: `/instance/basic/detail/${id}/${region}/${az}/performance`,
				query: {
					id,
					region,
					tabName,
					sn,
					imageType
				}
			});
		},
		jumpToCreate() {
			this.$router.push({
				name: 'CreateCase',
				query: { region: this.region }
			});
		},
		selectOps(caseOps, cps, operate, disabled, otherDisabled) {
			this.rowInfo = cps;
			if (disabled || otherDisabled) {
				return;
			}
			if (disabled) {
				return;
			}
			if (this.operateMap[this.statusListMap[cps.status]].indexOf(operate) > -1) {
				return;
			}
			Pop.ops(caseOps, this, cps, 'list');
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.hasCheckAll = val.length === this.tableData.length ? true : false;
			let isAllowBatchClose = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
			this.isAllowBatchClose = isAllowBatchClose;
			let isAllowBatchOpen = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;;
			this.isAllowBatchOpen = isAllowBatchOpen;
			let isAllowBatchRestart = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
			this.isAllowBatchRestart = isAllowBatchRestart;
			let isAllowBatchEditTag = this.multipleSelection.length ? this.multipleSelection.every(item => this.operateMap[this.statusListMap[item.status]].indexOf('editTag') < 0 && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
			this.isAllowBatchEditTag = isAllowBatchEditTag;
			let isAllowBatchRepassword = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;;
			this.isAllowBatchRepassword = isAllowBatchRepassword;
			let isAllowBatchRename = this.multipleSelection.length ? this.multipleSelection.every(item => item.charge.chargeStatus) : false;
			this.isAllowBatchRename = isAllowBatchRename;
			let isAllowBatchDelete = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && item.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION) : false;
			this.isAllowBatchDelete = isAllowBatchDelete;
			let multipleSelectionInstanceInfo = {};
			this.multipleSelection.map(item => {
				multipleSelectionInstanceInfo[item.instanceId] = item;
			})
			this.multipleSelectionInstanceInfo = multipleSelectionInstanceInfo;
		},

		resetMultipleSelection() {
			this.multipleSelection = [];
			this.multipleSelectionInstanceInfo = {};
		},

		batchOperateRefresh() {
			this.resetMultipleSelection();
			this.updateList('refresh');
		},
		showBatchCloseDialog() {
			this.batchCloseVisible = true;
		},
		showBatchOpenDialog() {
			this.batchOpenVisible = true;
		},
		showDownload() {
			this.downloadVisible = true;
		},
		handleCheckAllChange(event) {
			this.tableData.map(item => {
				this.$refs.listTable.toggleRowSelection(item, event)
			})
		},
		clickBatchOperate(value) {
			switch (value) {
				case 'restart':
					this.batchRestartVisible = true;
					break;
				case 'editTag':
					this.batchEditTagDialogVisible = true;
					break;
				case 'repassword':
					this.batchRepasswordVisible = true;
					break;
				case 'rename':
					this.batchRenameVisible = true;
					break;
				case 'delete':
					this.batchDeleteVisible = true;
					break;
				default:
					break;
			}
		},
		/**
		 * 增加了自定义脚本校验customSetData
		 * @return {boolean}
		 */
		public_net_confirm() {
			// 调整公网确认
			const server_data = this.public_net_gridData[0].server_data;
			if (this.public_net_slider_value < server_data.bandwidth) {
				this.$message.error(this.$t('listPage.speechCraft.confirmNet'));
				return;
			}
			this.public_net_dialog_visible = false;

			const target = this;
			// 创建临时订单
			const params = {
				orderType: 3,
				region: server_data.region,
				bw: this.public_net_slider_value,
				resourceId: server_data.instanceId,
				clientToken: this.clientToken,
				timestamps: this.clientToken,
				createType: CreateTypeConstant.BASIC,
				chargeMode: server_data.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : 1
			};
			Ajax.post('/api/cps/instances/modifyBandwidth', params)
				.then((res) => {
					const data = res.data;
					if (data.code) {
						if (data.code === '20701') {
							Pop.only_one(this);
							return false;
						}
						if (data.code === '20702') {
							Pop.repeat_order(this);
							return false;
						}
						if (data.code === '20703') {
							Pop.personal_buy(this);
							return false;
						}
					}
					if (data.tempOrderNumber) {
						const orderId = data.tempOrderNumber;
						if (orderId !== '' && orderId !== undefined) {
							window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
						}
					}
				});
		},
		checkExpire(row) {
			if (row.expire !== undefined) {
				const nowDate = new Date();
				const expireDate = new Date(row.expire);
				const retireDate = new Date(row.retireTime);
				const nowTime = nowDate.getTime();
				const expireTime = expireDate.getTime();
				const retireTime = retireDate.getTime();
				if (expireTime - nowTime < 7 * 24 * 3600 * 1000) {
					return 'will-expire';
				}
				if (retireTime - nowTime < 7 * 24 * 3600 * 1000) {
					return 'will-retire';
				}
				return 'available';
			}
		},
		createErrorOrder() {
			Normal.goWorkPage();
		},
		getAvailableOs() {
			const server_data = this.sys_rein_gridData[0].server_data;
			this.getAvailableRaids(server_data.deviceType, server_data.region);
			const params = {
				region: server_data.region,
				deviceType: server_data.deviceType,
				imageType: this.selectedImageType
			};
			Ajax.get({
				action: '/getAvailableOS',
				param: params,
				success: (data) => {
					const osTypes = {};
					this.customOsTypes = {};
					for (const i in data.oss) {
						const osTypeId = data.oss[i].osTypeId;
						const osType = data.oss[i].osType;
						const osName = data.oss[i].osName;
						const osVersion = data.oss[i].osVersion;
						if (!osTypes[osType]) {
							osTypes[osType] = [];
						}
						osTypes[osType].push({ osTypeId, osName });
						if (osType !== 'Ubuntu') {
							if (this.customOsTypes[osType] === undefined) {
								this.customOsTypes[osType] = [];
							}
							this.customOsTypes[osType].push({ osTypeId, osName });
						}
					}
					this.osTypes = osTypes;
					this.standardOsTypes = $.extend(true, {}, this.osTypes);
					if (osTypes.CentOS) {
						this.selectedOS = 'CentOS';
					} else {
						this.selectedOS = data.oss[0].osType;
					}
					if (this.selectedImageType !== 'standard_app') {
						this.osTypes = $.extend(true, {}, this.standardOsTypes);
					} else {
						this.selectedOS = 'CentOS';
						this.osTypes = $.extend(true, {}, this.customOsTypes);
					}
				}
			});
		},
		getAvailableRaids(deviceType, region) {
			const server_data = this.sys_rein_gridData[0].server_data;
			Ajax.get({
				action: '/getAvailableRaids',
				param: {
					deviceType,
					region
				},
				success: (data) => {
					const raids = [];
					for (const i in data.raids) {
						// 系统盘raids
						if (data.raids[i].volumeType !== 'system') {
							if (data.raids[i].raidType === 'NO RAID') {
								raids.splice(0, 0, data.raids[i]);
							} else {
								raids.push(data.raids[i]);
							}
						}
					}
					this.raids = raids;
					if (raids.length > 0) {
						this.selectedDataRaidId = server_data.dataRaidTypeId;
						this.selectedDataRaidType = server_data.dataRaidType;
					}
				}
			});
		},
		selectDataRaid(raidId, raidType) {
			this.selectedDataRaidId = raidId;
			this.selectedDataRaidType = raidType;
		},

		handleSizeChange(val) {
			this.pageSize = val;
			// console.log(this.pageSize)
			this.updateList('refresh');
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			// console.log(this.currentPage)
			this.updateList('refresh');
		},
		handleSearch(tags) {
			this.params = {};

			tags.map((item) => {
				if (item.key === "instanceId") {
					this.params.instanceIds = item.values.toString();
				}
				if (item.key === "name") {
					this.params.name = item.values.toString();
				}
				if (item.key === "privateIp") {
					this.params.privateIps = item.values.toString();
				}
				if (item.key === "publicIp") {
					this.params.publicIps = item.values.toString();
				}
				if (item.key === "filterStatusKey") {
					this.params.status = item.values.toString();
				}
				if (item.key === "filterSpecKey") {
					this.params.deviceTypeList = item.values.toString();
				}
			});
			this.searchOfList(this.params);
			if (tags.length !== 0) {
				this.searchList = true;
			} else {
				this.searchList = false;
			}
		},
		matchKeyFunction(keyValue) {
			let instanceIdReg = /^cps-[a-z0-9]/ig
			let ipv4Reg = /^((10|172|192)\.)((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){2}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
			keyValue = keyValue.replace(/，/g, ',').split(',')[0]
			if (instanceIdReg.test(keyValue)) {
				return {
					key: 'instanceId'
				}
			} else if (ipv4Reg.test(keyValue)) {
				return {
					key: 'privateIp',
					matchMode: "fuzzy"
				}
			}
			return false

		},
		// 返回最初列表
		backTolist() {
			this.tags = [];
			this.params = {};
			this.filterParams = {},
				this.searchList = false;
			this.pageSize = 20;
			this.currentPage = 1;
			this.hasCheckAll = false;
			this.resetMultipleSelection();
			this.$refs.listTable.clearFilter();
			this.updateList();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get({
				url: '/api/usercenter',
				action: '/getCustomInfo',
				param,
				success: (data) => {
					if (data.customInfo) {
						this.$store.commit('GET_CUSTOMINFO', { value: data.customInfo, type: this.type });
					}
				}
			});
		},
		getFilterLists() {
			const params = {
				region: this.region,
				networkType: 'basic'
			};
			Ajax.get('/api/filter/listInstances', params).then((res) => {
				if (res.errno === 10000 && res.data) {
					Object.keys(res.data).forEach((key) => {
						const filtersArray = [];
						const filtersObj = res.data[key];
						Object.keys(filtersObj).forEach((item) => {
							const temp = {};
							temp.value = item;
							temp.text = filtersObj[item];
							filtersArray.push(temp);
						});
						this.filters[key] = filtersArray;
						var json = JSON.parse(JSON.stringify(filtersArray).replace(/value/g, "key"))
						this.searchLists[key] = JSON.parse(JSON.stringify(json).replace(/text/g, "label"))
					});
					this.filterGroup.forEach((item) => {
						if (item.key === 'filterStatusKey') {
							item.selectOptions = this.searchLists.status;
						}
						if (item.key === 'filterSpecKey') {
							item.selectOptions = this.searchLists.deviceTypes;
						}
					})
				}
			}).finally(() => {
				this.azs = this.filters.azs;
				this.refreshloading = false;
			});
		},
		filterChange(filter) {
			this.currentPage = 1;
			//通过列表项的筛选条件自动获得的搜索框的搜索条件
			var tag = {};
			Object.keys(filter).forEach((key) => {
				if (key === 'filterAzKey') {
					this.filterParams.az = filter[key].toString();
				} else if (key === 'filterStatusKey') {
					this.filterParams.status = filter[key].toString();
				} else if (key === 'filterSpecKey') {
					this.filterParams.deviceTypeList = filter[key].toString();
				}
				tag.key = key;
				tag.values = filter[key];
				if (this.tags.length === 0 && tag.values.length) {
					this.tags.push(tag);
				} else {
					let isAdd = true;
					this.tags.forEach((item, index) => {
						if (item.key === tag.key) {
							item.values = tag.values;
							if (tag.values.length === 0) {
								this.tags.splice(index, 1);
							}
							isAdd = false;
						}
					})
					if (isAdd && tag.values.length) {
						this.tags.push(tag)
					}
				}
				if (!this.tags.length) {
					this.searchList = false;
				}
			});
			this.updateList();
		},
	}
};
</script>


<style lang="scss">
@import '../../../assets/scss/listComon';
@import '../../../assets/scss/paginationCommon';
@import '../../../assets/scss/sliderCommon';
@import '../../../assets/scss/statusCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/basicInstance/list/List.vue